import React from "react";

const Toast = ({ type, message, onClose }) => {
  let toastStyle = {};
  let icon;

  switch (type) {
    case "success":
      toastStyle = {
        backgroundColor: "#d4edda",
        color: "#155724",
        border: "1px solid #c3e6cb"
      };
      icon = <img src="/icon/Circle_Check.svg" />;
      break;
    case "error":
      toastStyle = {
        backgroundColor: "#f8d7da",
        color: "#721c24",
        border: "1px solid #f5c6cb"
      };
      icon = <img src="/icon/Error.svg" />;
      break;
    case "warn":
      toastStyle = {
        backgroundColor: "#fff3cd",
        color: "#CD8521",
        border: "1px solid #ffeeba"
      };
       icon = <img src="/icon/Warning.svg" />;
      break;
    default:
      toastStyle = {
        backgroundColor: "white",
        color: "#757575"
      };
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        maxWidth: "400px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        margin: "10px",
        borderRadius: "8px",
        padding: "16px",
        ...toastStyle
      }}
    >
      {icon}
      <p style={{ marginLeft: "10px" }}>{message}</p>
      <button
        onClick={onClose}
        style={{
          marginLeft: "auto",
          border: "none",
          background: "transparent"
        }}
      >
        <img src="/icon/Close_SM.svg" />
      </button>
    </div>
  );
};

export default Toast;
